// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"525":"ab84c67d","719":"c401f19d"}[chunkId] + ".chunk.js";
};